import {
  Button,
  Dialog,
  Backdrop,
  DialogTitle,
  DialogActions,
  DialogContent,
  CircularProgress,
  DialogContentText,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import apiService from 'library/api-service';
import { FormattedMessage } from 'react-intl';
import { Dispatch, SetStateAction, useState } from 'react';
import loaderLogoSrc from 'assets/images/idecon-loader-logo.png';
import { ProjectStepItem } from 'pages/project-step-managing/types';
import { removeCommentFromProjectStepTree } from 'pages/project-step-managing/utils';

type DeleteCommentDialogProps = {
  open: boolean;
  id: number | null;
  projectStepId: number | null;
  handleClose: () => void;
  setProjectSteps: Dispatch<SetStateAction<ProjectStepItem[]>>;
};

const DeleteCommentDialog = ({ open, id, projectStepId, handleClose, setProjectSteps }: DeleteCommentDialogProps) => {
  // other hooks
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    if (!id || !projectStepId) return;

    try {
      setLoading(true);

      const response = await apiService.deleteCommentFromProjectStep(id);

      if (response.isSuccess) {
        enqueueSnackbar(
          <FormattedMessage
            id="projectStepManaging.deleteSuccessMessage"
            defaultMessage="Seçili yorumu silme işlemi başarıyla tamamlandı."
          />,
          { variant: 'success' }
        );

        setProjectSteps((prev) => removeCommentFromProjectStepTree(prev, projectStepId, id));

        handleClose();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <FormattedMessage id="projectStepManaging.deleteComment" defaultMessage="Yorum Sil" />
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        <DialogContentText>
          <FormattedMessage
            id="projectStepManaging.deleteCommentText"
            defaultMessage="Bu işlem onaylandıktan sonra yorum veritabanından silinecektir. Silme işlemini onaylıyor musunuz?"
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={handleClose}>
          <FormattedMessage id="forgotPassword.cancel" defaultMessage="Vazgeç" />
        </Button>
        <Button variant="contained" type="button" onClick={handleDelete}>
          <FormattedMessage id="forgotPassword.continue" defaultMessage="Devam" />
        </Button>
      </DialogActions>
      <Backdrop
        sx={{ display: 'flex', flexDirection: 'column', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}>
        <img src={loaderLogoSrc} alt="loader-logo" />
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};

export default DeleteCommentDialog;
